import { MouseEvent, ReactElement } from "react";
import { useDispatch } from "react-redux";

import Button from "hardcover-ui/components/Button";
import { ButtonThemeProps } from "hardcover-ui/theme/components/button";
import useIsLoggedIn from "hooks/user/useIsLoggedIn";
import { uiActions } from "store/ui/uiSlice";

export default function UserJoinButtonActive({
  children,
  variant = "tertiary",
  size = "md",
  tab = "Login",
}: {
  children: ReactElement;
  variant?: ButtonThemeProps["variant"];
  size?: ButtonThemeProps["size"];
  tab: "Join" | "Login";
}) {
  const dispatch = useDispatch();
  const isLoggedIn = useIsLoggedIn();
  const toggleModal = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    dispatch(uiActions.toggleLoginVisible(tab));
  };

  if (isLoggedIn) {
    return false;
  }

  return (
    <Button variant={variant} size={size} onClick={toggleModal}>
      {children}
    </Button>
  );
}
